import { Card } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SearchContentTypeEnum } from '@juno/client-api/model';
import { JunoRotator } from '@juno/ui';
import { getContentRoute } from '@juno/utils';
import { useDirectoryData } from '../Contexts/DirectoryContext';

export const RecommendedUsers = () => {
  const {
    settings: { site },
    recommendedUsersQuery,
  } = useDirectoryData();
  const { data: recommendedUsers } = recommendedUsersQuery;

  const navigate = useNavigate();

  if (recommendedUsers?.length === 0) return null;

  return (
    <Card sx={{ p: 2, mb: 4 }}>
      <JunoRotator
        onSelect={(item) =>
          navigate(getContentRoute(site?.slug || '', item?.id || '', SearchContentTypeEnum.user))
        }
        settings={{
          title: 'Recommended Users',
          slideHeight: 90,
          slideWidth: 90,
        }}
        slides={
          recommendedUsers?.map((user) => {
            return {
              id: user.user.id,
              slug: user.user.id,
              name: `${user.user.first_name} ${user.user.last_name}`,
              description: user.user.email,
              image: user.user.icon || '',
            };
          }) || []
        }
      />
    </Card>
  );
};
